import { KpiResolver } from './resolvers/kpi.resolver';
import { Details2Component } from './components/Step 1/details2/details2.component';
import { HomeComponent } from './components/home/home.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Details1Component } from './components/Step 1/details1/details1.component';
import { CalculateInsSumResolver } from 'src/app/resolvers/calculate-ins-sum-resolver.service';
import { Details3Component } from './components/Step 1/details3/details3.component';
import { OfferComponent } from './components/Step 2/offer/offer.component';
import { Details4Component } from './components/Step 3/details4/details4.component';
import { MainComponent } from './components/main/main.component';
import { ErrorComponent } from './components/error/error.component';
import { OrderGuard } from './guards/order.guard';
import { ProposalGuard } from './guards/proposal.guard';
import { UnregisteredCarFormResolver } from './resolvers/unregisteredCarForm.resolver';
import { MyHomeFormResolver } from './resolvers/MyHomeForm.resolver';
import { ProposalResolver } from './resolvers/proposal.resolver';
import { OwnerDetailsComponent } from './components/owner-details/owner-details.component';
import { PolicyholderDetailsComponent } from './components/policyholder-details/policyholder-details.component';
import { StateGuard } from './guards/state.guard';
import { OwnerDetailsGuard } from './guards/owner-details.guard';
import { PremiumResolver } from './resolvers/premium.resolver';
import { MissingDetailsGuard } from './guards/missing-details.guard';
import { SubmitOfferGuard } from './guards/submit-offer.guard';
import { CheckOwnerGuard } from './guards/check-owner.guard';
import { AfterPaymentGuard } from './guards/after-payment.guard';
import { Details5Component } from './components/Step 3/details5/details5.component';
import { DataSummaryComponent } from './components/data-summary/data-summary.component';
import { ConsentsComponent } from './components/consents/consents.component';
import { CheckPolicyDataGuard } from './guards/check-policy-data.guard';
import { NormalizeUrlModule } from '@allianz/ngx-aem-integration'
import { EvrotrustGeneralComponent } from './components/evrotrust/evrotrust-general/evrotrust-general.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    resolve: {
      mainForm: MyHomeFormResolver
    },
    children: [
      {
        // remove if you want to keep the path for other application/page
        path: '', redirectTo: '/start', pathMatch: 'full'
      },
      {
        path: 'start',
        component: HomeComponent,
        data: {
          stepIndex: 0,
          progress: 0,
        }
      }, {
        path: 'object-details',
        component: Details1Component,
        canActivate: [MissingDetailsGuard],

        resolve: {
          // vehicle: VehicleResolver,
          // mainForm: MyHomeFormResolver
        },
        data: {
          stepIndex: 0, progress: 0.25
        }
      },
      {
        path: 'object-details-2',
        component: Details2Component,
        canActivate: [MissingDetailsGuard],
        data: {
          stepIndex: 0, progress: 0.5,
        }
      },
      {
        path: 'details-3',
        component: Details3Component,
        resolve: {
          vehicle: CalculateInsSumResolver
        },
        canActivate: [MissingDetailsGuard],
        data: {
          stepIndex: 0, progress: 0.75,
        }
      }, {
        path: 'newCarDetails-3',
        component: Details3Component,
        canActivate: [MissingDetailsGuard],
        data: {
          stepIndex: 0, progress: 0.75,
        }
      }, {
        path: 'summary',
        component: DataSummaryComponent,
        canActivate: [MissingDetailsGuard],
        data: {
          stepIndex: 3,
          //progress: 0.25,
          progress: 0,
        }
      }, {
        path: 'package-selection',
        component: OfferComponent,
        resolve: {
          mainForm: MyHomeFormResolver,
          productProposal: ProposalResolver,
          premium: PremiumResolver
        },
        canActivate: [ProposalGuard],
        data: {
          stepIndex: 1, progress: 1,
        }
      },
      {
        path: 'object-additional-details',
        component: Details4Component,
        canActivate: [MissingDetailsGuard],
        resolve: {
          mainForm: MyHomeFormResolver
        },
        data: {
          stepIndex: 2, progress: 0,
          title: 'object-additional-details.title',
        }
      }, {
        path: 'unregisteredCarFinalDetails',
        component: Details5Component,
        // canActivate: [MissingDetailsGuard, StateGuard],
        resolve: {
          mainForm: UnregisteredCarFormResolver
        },
        data: {
          stepIndex: 2, progress: 0,
        }
      }, {
        path: 'contact-details',
        component: OwnerDetailsComponent,
        // canActivate: [MissingDetailsGuard, OwnerDetailsGuard],
        data: {
          //stepIndex: 3, progress: 0,
          stepIndex: 2, progress: 0.25,
          title: 'registeredCar.title',
          heading: 'registeredCar.personalDetails',
          //image: 'woman-with-tablet-talking-to-man',
          rightPaddingBottom: '48px',
        }
      }, {
        path: 'contact-details-2',
        component: PolicyholderDetailsComponent,
        // canActivate: [MissingDetailsGuard, OwnerDetailsGuard],
        data: {
          stepIndex: 2, progress: 0.5,
          title: 'details4.title',
          heading: 'details4.personalDataTitle',
          //image: 'woman-with-tablet-talking-to-man',
          rightPaddingBottom: '48px',
        }
      }, {
        path: 'companyOwnerFinalDetails',
        component: OwnerDetailsComponent,
        canActivate: [OwnerDetailsGuard],
        data: {
          stepIndex: 3, progress: 0,
          formGroupName: 'companyOwnerData',
          title: 'registeredCar.title',
          heading: 'registeredCar.personalDetails',
          image: 'men-in-car',
          rightPaddingBottom: '48px',
          companyName: 'registeredCar.companyName',
          postCodeX: 'registeredCar.postCode',
          addressX: 'registeredCar.streetAndNumber',
          phoneNumber: 'registeredCar.phone',
          emailAddress: 'registeredCar.email',
          greenCard: true
        }
      }, {
        path: 'insurerData',
        component: OwnerDetailsComponent,
        canActivate: [CheckOwnerGuard],
        data: {
          stepIndex: 3, progress: 1,
          formGroupName: 'personInsurerData',
          title: 'registeredCar.yourFinalDetails',
          heading: 'registeredCar.yourPersonalDetails',
          image: 'woman-with-tablet-talking-to-man',
          rightPaddingBottom: '48px',
          egn: 'details3.pid',
          firstName: 'registeredCar.name',
          middleName: 'registeredCar.middleName',
          lastName: 'registeredCar.surname',
          postCodeX: 'registeredCar.postCode',
          addressX: 'registeredCar.streetAndNumber',
          phoneNumber: 'registeredCar.phone',
          emailAddress: 'registeredCar.email',
        }
      }, {
        path: 'consents',
        component: ConsentsComponent,
        canActivate: [MissingDetailsGuard],
        data: {
          formGroupName: 'agreement',
          title: 'consent.title',
          heading: 'consent.heading',
          image: 'woman-with-laptop-taking-picture-of-document',
          rightPaddingBottom: '52px',

          first: 'consent.first',
          first1: 'consent.first1',
          first2: 'consent.first2',
          second: 'consent.second',
          third: 'consent.third',
          third1: 'consent.third1',
          required: 'consent.required',
          agree: 'consent.agree',
          disagree: 'consent.disagree',
          errorMessage: 'consent.errorMessage',
          fourth: 'consent.fourth',
          fifth: 'consent.fifth',
          fifth2: 'consent.fifth2',
          stepIndex: 3, progress: 0.5,
          footerWithPrice: true,
          rightButtonsList: [{
            disabled: true,
            text: 'footer.continue',
            link: 'payment',
          }],
        }
      },
      {
        path: 'information',
        component: ErrorComponent,
        canActivate: [MissingDetailsGuard],
        data: {
          className: 'spacing',
          title: 'generalInfo.title',
          heading: 'generalInfo.heading',
          subHeading: 'generalInfo.mobileVerification',
          image: 'man-looking-at-tablet',

          // reload: true,
          footerWithPrice: true,
          stepIndex: 3, progress: 0.75,
          rightButtonsList: [
            {
              disabled: false,
              text: 'footer.continue',
              link: 'payment'
            }],
        }
      },
      {
        path: 'payment',
        canActivate: [CheckPolicyDataGuard],
        component: ErrorComponent,
        data: {
          title: 'payment.title',
          heading: 'payment.heading',
          isPayment: true,
          footerWithPrice: true,
          stepIndex: 3, progress: 0.85,
          rightButtonsList: [
            {
              disabled: false,
              text: 'footer.continuePay',
              link: 'successfulPayment'
            }],
          link: {
            type: 'secondary',
            label: 'payment.creditCard',
            classList: 'creditCard',
            path: '/payment',
            sendError: true,
            // path: '/order',
            icon: 'credit-card-o'
          }
        }
      },
      {
        path: 'successfulPayment',
        component: ErrorComponent,
        data: {
          stepIndex: 3, progress: 1,
          title: 'createOffer.title',
          heading: 'createOffer.heading',
          subHeading: 'createOffer.subHeading',
          subHeading1: 'createOffer.subHeading1',
          successIcon: true,
          finish: true,
        }
      }
    ]
  },
  {
    path: 'notFoundError',
    component: ErrorComponent,
    data: {
      title: 'error.title',
      heading: 'error.heading',
      subHeading: 'error.subHeading',
      errorMessage: 'error.errorMessage',
      phone: 'error.phone',
      showMobile: true,
      sendError: true,
      link: {
        disabled: true,
        type: 'primary medium',
        label: 'error.callMe',
      }
    },
    resolve: {
      kpi: KpiResolver
    }
  }, {
    path: 'notPreparedError',
    component: ErrorComponent,
    data: {
      title: 'error.titlePrepared',
      heading: 'error.headingPrepared',
      subHeading: 'error.subHeadingPrepared',
      errorMessage: 'error.errorMessage',
      phone: 'error.phone',
      showMobile: true,
      link: {
        disabled: true,
        type: 'primary medium',
        path: '/callAgent',
        label: 'error.callMe',
      }
    }
  }, {
    path: 'phoneNotVerified',
    component: ErrorComponent,
    data: {
      title: 'error.title',
      heading: 'error.headingPhoneNotVerified',
      subHeading: 'error.subHeadingWrong',
      errorMessage: 'error.errorMessage',
      phone: 'error.phone',
      showMobile: true,
      mobileError: true,
      link: {
        disabled: true,
        type: 'primary medium',
        path: '/callAgent',
        label: 'error.callMe',
      }
    },
    resolve: {
      kpi: KpiResolver
    }
  }, {
    path: 'somethingWentWrong',
    component: ErrorComponent,
    data: {
      globalClassName: 'wentWrong',
      // title: 'error.titleHome',
      heading: 'error.headingWrong',
      subHeading: 'error.subHeadingWrong',
      errorMessage: 'error.errorMessage',
      phone: 'error.phone',
      // image: 'left',
      showMobile: true,
      sendError: true,
      link: {
        disabled: true,
        type: 'primary medium',
        label: 'error.callMe',
      }
    },
    resolve: {
      kpi: KpiResolver
    }
  }, {
  path: 'expired-offer',
  component: ErrorComponent ,
  data: {
    globalClassName: 'wentWrong',
    title: 'error.titlePrepared',
    heading: 'error.subHeadingInvalid',
    expired:true,
    link: {
      type: 'primary medium',
      path: '/start',
      label: 'error.newOffer'
    }
  }
}, {
    path: 'createOffer',
    component: ErrorComponent,
    canActivate: [MissingDetailsGuard, SubmitOfferGuard],
    data: {
      title: 'createOffer.title',
      heading: 'createOffer.heading',
      successIcon: true
    }
  },
  {
    path: 'printPolicy',
    component: ErrorComponent,
    // canActivate: [SubmitOfferGuard],
    data: {
      title: 'createOffer.title',
      heading: 'renewOffer.heading',
      bottomText: 'createOffer.bottomText',
      subHeading: 'renewOffer.subHeading',
      successIcon: true,
      link: {
        type: 'primary',
        label: 'createOffer.btnText',
        classList: 'printButton',
        action: 'print'
        // path: '/order',
        // icon: 'credit-card-o'
      }
    }
  },
  {
    path: 'newPrintPolicy',
    component: ErrorComponent,
    //canActivate: [SubmitOfferGuard],
    data: {
      title: 'createOffer.title',
      heading: 'createOffer.heading',
      bottomText: 'createOffer.bottomText',
      subHeading: 'createOffer.subHeading',
      successIcon: true,
      link: {
        type: 'primary',
        label: 'createOffer.btnText',
        classList: 'printButton',
        action: 'new-print'
        // path: '/order',
        // icon: 'credit-card-o'
      }
    }
  },
  {
    path: 'order',
    component: ErrorComponent,
    canActivate: [OrderGuard],
    data: {
      title: 'payment.orderTitle',
      heading: 'payment.orderHeading',
      link: {
        type: 'secondary',
        label: 'error.backToHome',
        classList: 'creditCard',
        path: '/start',
      }
    }
  }, {
    path: 'unsuccessfulPayment',
    component: ErrorComponent,
    data: {
      className: 'spacing',
      title: 'payment.title',
      heading: 'payment.headingFailure',
      subHeading: 'payment.subHeadingFailure',
      paymentError: true,
      link: {
        type: 'primary',
        label: 'payment.goToPayment',
        path: '/payment'
      }
    }
  }, {
    path: 'callAgent',
    component: ErrorComponent,
    data: {
      globalClassName: 'callAgent',
      // title: 'error.title',
      heading: 'error.headingAgent',
      image: 'woman-with-laptop-and-headset',
      errorMessage: 'error.errorMessage',
      link: {
        type: 'primary medium',
        path: '/start',
        label: 'error.backToHome'
      }
    }
  }, {
    path: 'mobileInfo',
    component: OwnerDetailsComponent,
    data: {
      title: 'nofound.tellUs',
      heading: 'generalInfo.mobileVerification',
      image: 'man-looking-at-tablet',
      phone: 'registeredCar.phone',
      rightButtonsList: [
        {
          text: 'footer.continue',
          mode: 'primary',
          // disabled: '!parentForm.controls.vehicleDTO.valid',
          link: 'createOffer'
        }]
    }
  },
  {
    path: 'evrotrust',
    component: EvrotrustGeneralComponent
  },
  {
    path: '**', redirectTo: '/start', pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' }),

    NormalizeUrlModule],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
